import React from 'react';
import { Breadcrumb as BreadcrumbComponent, BreadcrumbItem } from '@/components/ui/Breadcrumb';

type BreadcrumbProps = {
  poolId: string;
};

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ poolId }) => {
  const items: BreadcrumbItem[] = [{ label: 'Pools & Dashboard', path: '/pools' }, { label: `Pool #${poolId}` }];

  return <BreadcrumbComponent items={items} />;
};
